import React, { useState } from "react";
import { Link } from "react-router-dom";

import domesticQR from "../../assets/Support-us/manas-qr.png";
import aboutUsBanner from "../../assets/Support-us/aboutus-banner.png";
import "../../styles/_support-us.scss";

export default function SupportUs() {
  const [showModal, setShowModal] = useState(false);

  function handleContactClick() {   
    if (window.history && window.history.length > 1) {
      window.history.back();
    } else {
      setShowModal(true);
    }
  }

  function scrollToQRs() {
    const qrSection = document.getElementById("contact");
    if (qrSection) {
      qrSection.scrollIntoView({ behavior: "smooth" });
    }
  }

  function handleContactUs() {
    window.location.href = "/#contact-form";
  }

  return (
    <div className="support-us-page">
      <section className="we-are-section" style={{ backgroundImage: `url(${aboutUsBanner})` }}>
        <div className="container">
          <h1>We are <span className="project-name">Project MA<span className="underline-text">NAS</span></span></h1>
          <p className="we-are-description">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>
          <div className="banner-ctas">
            <button className="btn btn-primary" onClick={scrollToQRs}>Support Us</button>
            <button className="btn btn-outline" onClick={handleContactUs}>Contact Us</button>
          </div>
        </div>
      </section>

      <main className="container support-us-content">
        <section className="support-contact" id="contact">
          <h2>Support Us</h2>

          <div className="qr-grid" aria-label="Crowdfunding options">
            <div className="qr-card-wrapper">
              <figure className="qr-card">
                <figcaption>Domestic crowdfunding</figcaption>
                <a href="https://example.com/domestic" target="_blank" rel="noopener noreferrer" aria-label="Domestic crowdfunding link">
                  <img className="qr-image" src={domesticQR} alt="Domestic crowdfunding QR" width="220" height="220" />
                </a>
              </figure>
              <button className="btn qr-btn">Donate Domestic</button>
            </div>

            <div className="qr-card-wrapper">
              <figure className="qr-card">
                <figcaption>International crowdfunding</figcaption>
                <a href="https://example.com/international" target="_blank" rel="noopener noreferrer" aria-label="International crowdfunding link">
                  <img className="qr-image" src={domesticQR} alt="International crowdfunding QR" width="220" height="220" />
                </a>
              </figure>
              <button className="btn qr-btn">Donate International</button>
            </div>
          </div>

          {showModal && (
            <div className="contact-modal" role="dialog" aria-modal="true">
              
            </div>
          )}
        </section>
      </main>
    </div>
  );
}